import { useMonthlyEnergyRoutes } from "./routes";
import { GetDefaultIndex } from "../../components";
import { useGetMonthlyEnergyCommonInfoQuery } from "../../features/api/monthlyEnergyApi";

export { useMonthlyEnergyRoutes };

interface MonthlyEnergysProps {
  isCumulative: boolean;
}

const MonthlyEnergies = ({ isCumulative }: MonthlyEnergysProps) => {
  let title = isCumulative ? "انرژی ماهانه تجمعی" : "انرژی ماهانه";

  return GetDefaultIndex({
    title: title,
    query: useGetMonthlyEnergyCommonInfoQuery,
    queryArgs: isCumulative,
  })();
};

export default MonthlyEnergies;
